import nlMessages from 'ra-language-dutch';

const nl = {
    ...nlMessages,
    resources: {
        events: {
            name: 'Evenement |||| Evenementen',
            fields: {
                title: 'Titel',
                category: 'Categorie',
                country_id: 'Land',
                region_id: 'Regio',
                Start_at: 'Begin',
                end_at: 'Einde',
                online: 'Online',
                on_site: 'Ter plaatse',
                lat: 'Breedtegraad',
                lng: 'Lengtegraad',
                address: 'Adres',
                organization_name: 'Organisatienaam',
                organization_website: 'Organisatie website',
                organization_contact_info: 'Organisatie contact info',
                intro: 'Introductie',
                content: 'Inhoud',
                status: 'Status',
                published: 'Gepubliceerd'
            }
        },
        account: {
            fields: {
                firstname: 'Voornaam',
                lastname: 'Achternaam',
                password: 'Wachtwoord',
                job_title: 'Functieomschrijving',
                organization_name: 'Organisatienaam',
                organization_address: 'Organisatieadres',
                organization_website: 'Organisatie website',
                organization_contact_name: 'Naam contactpersoon organisatie',
                organization_contact_email: 'E-mail contactpersoon organisatie',
            }
        }
    },
    'Total': 'Totaal',
    'My upcoming event(s)': 'Mijn aankomende evenement(en)',
    'Join us and create an event': 'Doe met ons mee en creëer een evenement',
    'Once your event is created the Europe Members team will review your event. If everything is in order, you will be prompted by e-mail and you will be able to publish your event.': 'Zodra uw evenement is aangemaakt, zal het team van Europe Remembers uw evenement bekijken. Als alles in orde is, krijgt u een e-mail en kunt u uw evenement publiceren.',
    'Create event': 'Een evenement maken',
    'Search': 'Zoeken',
    'Country': 'Land',
    'Region': 'Regio',
    'Published': 'Gepubliceerd',
    'Online': 'Online',
    'On site': 'Ter plaatse',
    'Draft': 'Ontwerp',
    'Review': 'In evaluatie',
    'Accepted': 'Geaccepteerd',
    'Refused': 'Geweigerd',
    'Commemoration': 'Commemoratie',
    'Conference': 'Conferentie',
    'Festival': 'Festival',
    'Guided tour': 'Rondleiding',
    'Exhibition': 'Tentoonstelling',
    'Music-Theater': 'Muziek-Theater',
    'Other': 'Extra',
    'Ask for review': 'Vraag voor evaluatie',
    'Do you want to ask a review for the event': 'Wil je een evaluatie vragen voor het evenement?',
    'Unpublish': 'Onpubliceren',
    'Do you want to unpublish the event': 'Will je het evenement onpubliceren?',
    'Event published': 'Evenement gepubliceerd',
    'Event unpublished': 'Evenement ongepubliceerd',
    'Publish': 'Publiceren',
    'Do you want to publish the event': 'Wil je het evenement publiceren?',
    'Summary': 'Samenvatting',
    'Translations': 'Vertalingen',
    'Pictures': 'Foto\'s',
    'Title': 'Titel',
    'Intro': 'Introductie',
    'Content': 'Inhoud',
    'Picture': 'Foto',
    'Description': 'Beschrijving',
    'Copyright': null,
    'Featured': null,
    'Account': null,
    'Account updated': 'Account bijgewerkt',
    'Forgot password?': 'Wachtwoord vergeten?',
    'Forgot password': 'Paswoord vergeten',
    'An email has been sent': 'Er is een email verzonden',
    'Email': 'Email',
    'Reset password': 'Wachtwoord opnieuw instellen',
    'Main picture': 'Hoofdbeeld',
    'Default language': 'Standaard taal',
    'Event website': 'Evenement website',
    'Europe Remembers : How to create an event ?': 'Europe Remembers: Hoe maak je een evenement aan?',
    'Turn on subtitles (CC) to get instructions in your language.': 'Zet ondertiteling (CC) aan om instructies in jouw taal te krijgen.',
    'Contribute to the project!': 'Draag bij \naan het project!',
    'Europe Remembers aims to give visibility to your events and is free to use ! However we need your contributions to help us maintain and keep this platform running.': 'Europe Remembers wil zichtbaarheid geven aan jouw evenementen en is gratis te gebruiken! Maar we hebben jouw bijdragen nodig om dit platform te onderhouden en draaiende te houden.'
};

export default nl;